import React from "react";
import "./ThemeToggle.css";

export default function ThemeToggle({ mode, onToggle }) {
  return (
    <div className="theme-toggle-container">
      <input
        type="checkbox"
        id="theme-toggle-checkbox"
        className="toggle-checkbox"
        checked={mode === "dark"}
        onChange={onToggle}
      />
      <label htmlFor="theme-toggle-checkbox" className="toggle-label">
        <div className="wipe-overlay" />

        <div className="night-sky">
          <div className="star star-1" />
          <div className="star star-2" />
          <div className="star star-3" />
          <div className="star star-4" />
          <div className="star star-5" />
          <div className="star star-6" />
          <div className="shooting-star" />
        </div>

        <div className="cloud-group">
          <div className="cloud-back" />
          <div className="cloud-front" />
        </div>

        <div className="knob">
          <span className="emoji-sun">☀️</span>
          <span className="emoji-moon">🌝</span>
        </div>
      </label>
    </div>
  );
}
